import React, { useState } from 'react'
import MaterialTable from 'material-table'
import PropTypes from 'prop-types'
import { setConfigurations } from '../api/store-utils'

const cdpSelect = { 1: 1, 2: 2 }

const getBrandsSelect = (brands) => {
  const brandsSelect = {}
  brands.forEach(brand => { brandsSelect[brand] = brand })
  return brandsSelect
}

const getStoresSelect = (brands, stores) => {
  const storesSelect = {}
  brands.forEach(brand =>
    stores[brand].forEach(store => { storesSelect[store.storeName] = store.storeName }))
  return storesSelect
}

const getRows = (stores) => {
  const rows = []
  Object.keys(stores).map(brand =>
    stores[brand].map(store =>
      store.configurations.map(
        configuration => rows.push(getRow(configuration, store, brand)))))
  return rows
}

const getRow = (configuration, { storeName }, brand) => {
  return {
    brand: brand,
    store: storeName,
    cpd: configuration.cpd,
    key: configuration.key,
    value: configuration.value
  }
}

const handleRowAdd = (env, data, setData, { brand, store, cpd, key, value }) => {
  const _data = [...data]
  if (key && _data.filter(t => t.cpd === cpd && t.key === key && t.store === store).length === 0) {
    setConfigurations(env, brand, store, [{ key, value, cpd }])
    _data.push({ brand, store, cpd, key, value })
    setData(_data)
  }
}

const handleRowOperations = (env, brand, storeName, cpd, key, value) => {
  setConfigurations(env, brand, storeName, [{ cpd, key, value }])
}

const refreshUpdateRow = (data, setData, { brand, store, cpd, key, tableData }, value) => {
  const _data = [...data]
  _data[tableData.id] = { brand, store, cpd, key, value }
  setData(_data)
}

const handleDeleteRows = (env, data, setData, rowData) => {
  let _data = [...data]
  const tableIds = []
  const configsByStore = {}
  rowData.forEach(row => {
    if (!configsByStore[row.store]) {
      configsByStore[row.store] = []
    }
    configsByStore[row.store].push(row)
  })

  for (const storeIndex in configsByStore) {
    const rows = configsByStore[storeIndex]
    const configurations = []
    for (const rowIndex in rows) {
      const key = rows[rowIndex].key
      const cpd = rows[rowIndex].cpd
      configurations.push({ key, cpd })
      tableIds.push(rows[rowIndex].tableData.id)
    }
    setConfigurations(env, rows[0].brand, rows[0].store, configurations)
  }
  _data = _data.filter(r => !tableIds.includes(r.tableData.id))
  setData(_data)
}

const AllConfigurationsTable = ({ brands, stores, env }) => {
  const [data, setData] = useState(getRows(stores))
  return (
    <MaterialTable
      title='Configurations for all brands'
      columns={[
        { title: 'Brand', field: 'brand', editable: 'onAdd', lookup: getBrandsSelect(brands) },
        { title: 'Store', field: 'store', editable: 'onAdd', lookup: getStoresSelect(brands, stores) },
        { title: 'Cpd', field: 'cpd', editable: 'onAdd', lookup: cdpSelect },
        { title: 'Key', field: 'key', editable: 'onAdd' },
        { title: 'Value', field: 'value' }
      ]}
      editable={{
        onRowAdd: (newData) => {
          return new Promise((resolve) => {
            handleRowAdd(env, data, setData, newData)
            setTimeout(resolve, 1000)
          })
        },
        onRowUpdate: (newData, oldData) => {
          return new Promise((resolve) => {
            handleRowOperations(env, oldData.brand, oldData.store, oldData.cpd, oldData.key, newData.value)
            refreshUpdateRow(data, setData, oldData, newData.value)
            setTimeout(resolve, 1000)
          })
        }
      }}
      data={data}
      actions={[
        {
          icon: 'delete',
          tooltip: 'Delete Rows',
          onClick: (event, rowData) => {
            if (window.confirm('You want to delete ' + rowData.length + ' configurations')) {
              handleDeleteRows(env, data, setData, rowData)
            }
          }
        }
      ]}
      options={{
        headerStyle: { position: 'static' },
        selection: true,
        pageSize: 10,
        actionsColumnIndex: -1
      }}
    />
  )
}

AllConfigurationsTable.propTypes = {
  brands: PropTypes.arrayOf(PropTypes.string),
  env: PropTypes.string,
  stores: PropTypes.objectOf(
    PropTypes.arrayOf(PropTypes.shape({
      storeName: PropTypes.string,
      configurations: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string,
          value: PropTypes.string
        })
      )
    }))).isRequired
}

export default AllConfigurationsTable
